import { css } from 'styled-components';

export const Family = { // eslint-disable-line
	robot: css`
		font-family: 'Roboto', sans-serif;
	`,
	prompt: css`
		font-family: 'Prompt', sans-serif;
	`,
	Nunito: css`
		font-family: 'Nunito', sans-serif;
	`,
	ProximaNovaBold: css`
		font-family: 'Proxima Nova', sans-serif;
		font-weight: bold;
	`,
	ProximaNovaNormal: css`
		font-family: 'Proxima Nova', sans-serif;
	`,
};
